import React from 'react'

import { Modal } from 'src/components/Ant'

import Table from './table'

interface Props {
  toggle: () => void
  visible: boolean
}

function ModalIntegration({ visible, toggle }: Props): JSX.Element {
  return (
    <>
      <Modal
        cancelButtonProps={{ hidden: true }}
        destroyOnClose
        maskClosable
        okButtonProps={{ hidden: true }}
        onCancel={toggle}
        onOk={() => {}}
        title="web.integration.modal-title"
        visible={visible}
        width={800}
      >
        <Table />
      </Modal>
    </>
  )
}

export default ModalIntegration
